import {
  getActa,
  getMisActas,
  primeraEtapa,
  segundaEtapa,
  terceraEtapa,
} from "../services/actas.service";
import { cambiarEstadoActa, enviarConstatacion, getActas } from "../services/admin.service";
import { useAdminStore } from "../store/adminStore";
import { useDataUserStore } from "../store/dataUserStore";
import { useFormActaStore } from "../store/formActaStore";
import { useGeneralAppStore } from "../store/generalAppStore";

const { setMisActas } = useDataUserStore.getState();
const { setDefaultValues, formActive, setFormActive } = useFormActaStore.getState();
const { setActas, setActa, setSolicitudesAsignar, setRefetch } = useAdminStore.getState();
const { handlerModal } = useGeneralAppStore.getState();

export const handleActas = async (estado_actas) => {
  const result = await getActas(estado_actas);
  if (result) {
    setActas(result);
    // setSolicitudesAsignar([]);
  }
};

export const handlerGetActa = async (payload) => {
  const result = await getActa(payload);
  if (result) {
    setActa(result);
    handlerModal({ modal: true, modalName: "get_acta" });
  }
};

export const handlerSubirConstatacion = async (payload) => {
  const result = await enviarConstatacion(payload);
  if (result) {
    console.log(result);
    setActa(result);
    setRefetch(true);

    // setActa(result);
    handlerModal({ modal: false, modalName: "modal_constatacion" });
  }
};

export const handlerCambiarEstado = async (payload) => {
  const result = await cambiarEstadoActa(payload);
  if (result) {
    setActa(result);
    setRefetch(true);
    // let { acta } = useAdminStore.getState();
    // let { defaultValues } = useFormActaStore.getState();
    // if (acta) {
    //   setActa(result);
    //   const refreshActas = await getActas();
    //   if (refreshActas) {
    //     setActas(refreshActas);
    //   }
    // }
    // if (defaultValues) {
    //   setDefaultValues(result);
    // }
  }
};

//! OOOOOOOOLDDDDDDDDDDDDDDDDD

export const handlerMisActas = async () => {
  const result = await getMisActas();
  if (result) setMisActas(result);
};

export const primeraEtapaHandler = async (payload) => {
  const result = await primeraEtapa(payload);
  if (result) {
    setDefaultValues(result);
  }
};

export const segundaEtapaHandler = async (payload, id) => {
  const result = await segundaEtapa(payload, id);
  if (result) {
    setDefaultValues(result);
  }
};

export const terceraEtapaHandler = async (payload, id) => {
  const result = await terceraEtapa(payload, id);
  if (result) {
    setDefaultValues(result);
  }
};
